'use client';

import CustomRandomReveal from '@/lib/utils/CustomRandomReveal';
import { useState } from 'react';

const Intro = () => {
  const _renderTextName = (titles: string[]) => {
    const [count, setCount] = useState(0);
    const caret = typeof document !== 'undefined' ? document.getElementsByClassName("typewriter-container")[0] : undefined;

    return (
      <span className="typewriter-container pause">
        <CustomRandomReveal
          previous={titles[count]}
          next={titles[count === (titles.length - 1) ? 0 : count + 1]}
          interval={100}
          delay={2}
          caret={caret}
          onComplete={() => {
            if (count === titles.length - 1) {
              setCount(0);
            }
            else {
              setCount(count + 1);
            }
          }}
        />
      </span>
    )
  };

  return (
    <div className='content-left-box'>
      <h2 className='text-gray letter-scrambler'>{`\\\\INTRO\\\\`}</h2>
      <div>
        <h1 className='letter-scrambler'>
          WE RUN ON EXPERIMENTATION AND CREATIVITY.
          INVENTED FROM ADVERTISING AND PRODUCTION SPHERES,
          THE OTHER LAB THRIVES ON MATERIALISING IDEAS WITH A TEAM OF HIGHLY SKILLED 
          <span> {_renderTextName(['CREATIVES', 'SUITS', 'DEVELOPERS', 'PROGRAMMERS', 'ARTISTS', 'ILLUSTRATORS', 'DESIGNERS'])}</span>
        </h1>
      </div>
      <p className={'text-gray'}>{'<>'}</p>
    </div>
  )
};

export default Intro;